import { PaperClipOutlined, SearchOutlined } from '@ant-design/icons';
import { Popover } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { FileListModule } from '../FileUploaderListManager/enum/FileListModule';
import { useFilesPreviewHandler } from './hooks/useFilesPreviewHandler';

const Styled = styled.div`
    .icon__clip {
        font-size: 17px;
        cursor: pointer;
    }

    .blurred {
        color: #bfbfbf; /* grey-6 */
        cursor: default;
    }
`;

/**
 * Pops up Lightbox when the icon is clicked, will not be clickable if there are no files.
 * Props:
 * @param {FileListModule} type - TRANSACTION, CONTACT, FILE_MANAGER
 * @param {{id: number, type: string|null}} record - record object, type eg: sale_invoice, purchase_order
 */
export function FilesPreview({
    type,
    record,
    onMaskClick = e => e.stopPropagation(),
}) {
    const {
        onClickRead,
        popoverContent,
    } = useFilesPreviewHandler(type, record);

    const renderChildren = () => {
        switch (type) {
            case FileListModule.FILE_MANAGER:
                return <SearchOutlined onClick={onClickRead} />;
            case FileListModule.TRANSACTION:
            case FileListModule.CONTACT:
            default:
                return (
                    <Popover content={popoverContent}>
                        <PaperClipOutlined
                            className={`icon__clip ${!record.file_count && 'blurred'}`}
                            onClick={record.file_count ? onClickRead : undefined}
                        />
                    </Popover>
                );
        }
    };

    return (
        <Styled onClick={onMaskClick}>
            <span className="lightbox-preview-icon">
                {renderChildren()}
            </span>
        </Styled>
    );
}
